import LandingPageContainer from './landing_page_container';

const LandingPage = LandingPageContainer;
export default LandingPage;
